import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  projectId: "talisman-ai-agent-9cb94",
  appId: "1:528270436512:web:9fb806daf14d2365ad01c5",
  storageBucket: "talisman-ai-agent-9cb94.firebasestorage.app",
  apiKey: "AIzaSyDr5LnsQSBV7efH6F82kji-QRErXekgnqg",
  authDomain: "talisman-ai-agent-9cb94.firebaseapp.com",
  messagingSenderId: "528270436512",
  measurementId: "G-VPWY8Y6LZP"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
